import StateHelper from "./StateHelper";
import { AuthUserPermissions, UserPermissions } from "./types";

export function isAdminUser(): boolean {
	return StateHelper.getUserState().permissions != null && StateHelper.getUserState().permissions.includes(UserPermissions.adminSuperUser);
}

export function isAllowedRTBData(): boolean {
	return isAdminUser() || StateHelper.getUserState().permissions.includes(UserPermissions.appptapDataRtb);
}

export function isAllowedGrossRevenueData(): boolean {
	return isAdminUser() || StateHelper.getUserState().permissions.includes(UserPermissions.appptapDataGrossRevenue);
}

export function isAllowedFilterField(field:string): boolean {
	return isAdminUser() || (StateHelper.getUserState().filterFields != null && StateHelper.getUserState().filterFields.includes(field));
}

export function canEditCLink(): boolean {
	return isAdminUser() || (StateHelper.getUserState().clinks && StateHelper.getUserState().clinks.clinkEditScope && StateHelper.getUserState().clinks.clinkEditScope.length) ? true : false;
}

export function canEditClinkField(field: string): boolean {
	return isAdminUser() || (StateHelper.getUserState().clinks &&
					StateHelper.getUserState().clinks.clinkEditScope &&
					(StateHelper.getUserState().clinks.clinkEditScope.includes('ALL_FIELDS') ||
					StateHelper.getUserState().clinks.clinkEditScope.includes(field))) ? true : false;
}

export function hasPermission(permission: AuthUserPermissions): boolean {
  return StateHelper.getUserState()?.authUserPermissions?.includes(permission);
}